import * as actionTypes from "../actionTypes.js";

const initialState = {
  currenciesList: null,
  usersList: null
};

const consumerPaymentReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.GET_CURRENCIES_CON_PAYMENTS:
      return { ...state, currenciesList: action.payload };
    case actionTypes.GET_USERS_CON_PAYMENTS:
      return { ...state, usersList: action.payload };

    case actionTypes.LOG_OUT:
      return initialState;

    default:
      return state;
  }
};

export default consumerPaymentReducer;